export default ({ palette, typography }) => ({
  wrap: {
    color: palette.text.dark,
    boxShadow: '1px 1px 10px rgba(0,0,0,0.2);',
    borderLeft: '4px solid',
    padding: [16, 16, 16, 20],
    borderRadius: 4,
    ...typography.text
  },
  positive: {
    borderColor: palette.colors.emerald,
    '& $alertIcon svg': {
      fill: palette.colors.emerald
    }
  },
  warning: {
    borderColor: palette.colors.yellowOrange,
    '& $alertIcon svg': {
      fill: palette.colors.yellowOrange
    }
  },
  negative: {
    borderColor: palette.form.error,
    '& $alertIcon svg': {
      fill: palette.form.error
    }
  },
  info: {
    borderColor: palette.primary.light,
    '& $alertIcon svg': {
      fill: palette.primary.light
    }
  },
  alertTitle: {
    margin: 0,
    fontWeight: typography.fontWeightHeavy,
    fontFamily: typography.fontFamily
  },
  alertIcon: {
    marginRight: 24,
    '& svg': {
      width: 24,
      height: 24
    }
  },
  alertDetails: {
    marginTop: 2
  },
  btnDetails: {},
  labelDetails: {
    display: 'none'
  },
  IconDetails: {
    height: 16,
    width: 16,
    marginRight: 8,
    marginTop: 4,
    '& svg': {
      fill: '#4c4c4c'
    }
  },
  alertMessage: {
    fontSize: 16,
    margin: 0,
    fontFamily: typography.fontFamily
  },
  closeButton: {
    '& svg': {
      fill: '#4c4c4c',
      height: 16
    }
  },
  focusColor: palette.focus.normal
});
